import { useState, useRef, useCallback } from 'react';
import debounce from '../Utils/debouncer.js';

/**
 * Hook handles mouse over state and calls the onMouseOver and onMouseOut callbacks.
 * Gestisce anche un debounce per non scatenerare troppe callback.
 */
function useMouseOver(onMouseOverCB, onMouseOutCB) {
    const [mouseOver, setMouseOver] = useState(false);
    const callbackRef = useRef(debounce((over, setOver, onOverCB, onOutCB) => {
        if (over && onOverCB)
            onOverCB();
        if (!over && onOutCB)
            onOutCB();
        setOver(over);
    }, 200));
    const onMouseOver = useCallback(() => {
        callbackRef.current(true, setMouseOver, onMouseOverCB, undefined);
    }, [onMouseOverCB]);
    const onMouseOut = useCallback(() => {
        callbackRef.current(false, setMouseOver, undefined, onMouseOutCB);
    }, [onMouseOutCB]);
    return [mouseOver, onMouseOver, onMouseOut];
}

export { useMouseOver as default };
